import Form from "./App/FormPage";
import FormPage from "./App/FormPage";

function App() {
  return <FormPage/>
}

export default App;
